/**
 * @file コンポーネント：検索執刀医絞り込み ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useState } from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// 関数読み込み
import {
    fnGetCultureLanguage,
    fnGetSurgeonFullName,
} from "~/src/functions/common";

// コンポーネントを返す
export const SearchSurgeon = (props) => {
    /**
     * 執刀医リスト生成
     */
    const [list, setList] = useState([]); // 執刀医リスト
    const languageCode = fnGetCultureLanguage(); // UI表示言語
    useEffect(() => {
        if (props.surgeonlist) {
            const tempList = props.surgeonlist.map((country) => {
                let flagIsOpen = false; // 国のトグル状態
                const surgeons = country.surgeons.map((surgeon) => {
                    const regexp = new RegExp(surgeon.searchUrl);
                    const flagIsActive = regexp.test(location.pathname); // 執刀医のアクティブ状態
                    // 執刀医にアクティブがある場合、親の国のトグルを開く
                    if (flagIsActive) {
                        flagIsOpen = true;
                    }
                    const surgeonName = fnGetSurgeonFullName(
                        surgeon,
                        languageCode
                    );
                    return {
                        href: surgeon.searchUrl,
                        isActive: flagIsActive,
                        text: surgeonName + " (" + surgeon.count + ")",
                    };
                });
                return {
                    children: surgeons,
                    isOpen: flagIsOpen,
                    text:
                        country.countryName + " (" + country.surgeonCount + ")",
                };
            });
            setList(tempList);
        }
    }, [props.surgeonlist]);

    // Presenterに渡す
    return <Presenter list={list} {...props} />;
};
